import axios from 'axios';

const API_URL ='/api/v1/users'

// Register user
const register = async (userData) => {
    const response = await axios.post(`${API_URL}/create_account`, userData)

    if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data))
    }

    return response.data
}

// Login user
const login = async (userData) => {
    const response = await axios.post(`${API_URL}/login`, userData)

    if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data))
    }

    return response.data
}

//logout

const logout = () => {
    localStorage.removeItem('user')
}
const authService = {
    register, logout, login
}

export default authService
